import { useEffect } from 'react';
import { useTimeTracking } from '../components/context_providers/TimeTrackingContext';

const APP_TITLE = 'Zerve My Time';

const formatTime = (totalSeconds: number): string => {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
};

export const useBrowserTitle = (): void => {
  const { activeTimer } = useTimeTracking();

  useEffect(() => {
    if (activeTimer && activeTimer.elapsedSeconds > 0) {
      document.title = `${formatTime(activeTimer.elapsedSeconds)} - ${APP_TITLE}`;
    } else {
      document.title = APP_TITLE;
    }

    return () => {
      document.title = APP_TITLE;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTimer?.elapsedSeconds]);
};
